import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function confirmPasswordValidator(passwordControl: AbstractControl): ValidatorFn {
  return (confirmPasswordControl: AbstractControl): ValidationErrors => {
    const password = passwordControl.value;
    const confirmedPassword = confirmPasswordControl.value;

    if (password !== confirmedPassword) {
      return { confirmPassword: true };
    }

    return null;
  }
}
